export default __webpack_public_path__ + "static/media/select-states-arrow.eaa596c6.svg";